// import { motion } from "framer-motion";
// import { Facebook, Instagram, Linkedin, Mail, Globe2 } from "lucide-react";
// import { Link } from "react-router-dom";
// import "./Navbar.css";

// export default function Footer() {
//   const currentYear = new Date().getFullYear();

//   // ✅ SERVICES – Correct labels & paths
//   const services = [
//     { name: "Website Development", href: "/services/web" },
//     { name: "Mobile App Development", href: "/services/mobile" },
//     { name: "E-Commerce Development", href: "/services/ecommerce" },
//     { name: "Cloud Solutions", href: "/services/cloud" },

//   ];

//   // ✅ PRODUCTS – Correct labels & paths
//   const products = [
//     { name: "ERP System", href: "/Erp" },
//     { name: "CRM System", href: "/Crm" },
//     { name: "HRM System", href: "/Hrm" },
//     { name: "Billing & Invoicing", href: "/Billing" },
//   ];

//   const quickLinks = [
//     { name: "Home", href: "/" },
//     { name: "About Us", href: "/about" },
//     { name: "Company", href: "/company" },
//     { name: "Careers", href: "/careers" },
//   ];

//   const socialLinks = [
//     {
//       icon: Linkedin,
//       href: "https://www.linkedin.com/in/infronex-it-product-and-services-109929361/",
//     },
//     {
//       icon: Instagram,
//       href: "https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=xtyu37w",
//     },
//     { icon: Facebook, href: "https://www.facebook.com/share/15dq6rpGBY/" },
//     { icon: Mail, href: "mailto:info@infronex.com" },
//   ];

//   return (
//     <footer className="bg-[#0f172a] text-slate-400 pt-20 pb-8 border-t border-white/5">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8">
//         {/* TOP GRID */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14 mb-14">
//           {/* BRAND */}
//           <div className="space-y-6">
//             <motion.div
//               initial={{ opacity: 0, x: -20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//             >
//               <h3 className="text-2xl font-black text-white uppercase brand-motion1">
//                 INFRONEX
//               </h3>
//               <p className="text-sm leading-relaxed italic max-w-xs mt-3">
//                 Architecting scalable digital products and enterprise-grade
//                 software solutions.
//               </p>
//             </motion.div>

//             {/* SOCIAL */}
//             <div className="flex gap-3">
//               {socialLinks.map((item, i) => {
//                 const Icon = item.icon;
//                 return (
//                   <a
//                     key={i}
//                     href={item.href}
//                     target="_blank"
//                     rel="noreferrer"
//                     className="w-10 h-10 flex items-center justify-center rounded-xl border border-white/10 hover:border-indigo-500 hover:text-white transition"
//                   >
//                     <Icon size={18} />
//                   </a>
//                 );
//               })}
//             </div>
//           </div>

//           {/* SERVICES */}
//           <div>
//             <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
//               Services
//             </h4>
//             <ul className="space-y-4">
//               {services.map((item, i) => (
//                 <li key={i}>
//                   <Link
//                     to={item.href}
//                     className="hover:text-indigo-400 text-sm"
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* PRODUCTS */}
//           <div>
//             <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
//               Products
//             </h4>
//             <ul className="space-y-4">
//               {products.map((item, i) => (
//                 <li key={i}>
//                   <Link
//                     to={item.href}
//                     className="hover:text-indigo-400 text-sm"
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* QUICK LINKS */}
//           <div>
//             <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
//               Quick Links
//             </h4>
//             <ul className="space-y-4">
//               {quickLinks.map((item, i) => (
//                 <li key={i}>
//                   <Link
//                     to={item.href}
//                     className="hover:text-indigo-400 text-sm"
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         {/* BOTTOM BAR */}
//         <div className="pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs uppercase tracking-widest text-slate-500">
//           <div className="flex items-center gap-2">
//             <Globe2 size={14} className="text-indigo-500" />
//             <span>Coimbatore, India</span>
//           </div>

//           <p>© {currentYear} Infronex IT Products and Services</p>
//         </div>
//       </div>
//     </footer>
//   );
// }

import { motion } from "framer-motion";
import {
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  Globe2,
  MapPin,
  Phone,
} from "lucide-react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: "Website Development", href: "/services/web" },
    { name: "Mobile App Development", href: "/services/mobile" },
    { name: "E-Commerce Development", href: "/services/ecommerce" },
    { name: "Cloud Solutions", href: "/services/cloud" },
  ];

  const products = [
    { name: "ERP System", href: "/Erp" },
    { name: "CRM System", href: "/Crm" },
    { name: "HRM System", href: "/Hrm" },
    { name: "Billing & Invoicing", href: "/Billing" },
  ];

  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about" },
    { name: "Company", href: "/company" },
    { name: "Careers", href: "/careers" },
  ];

  const socialLinks = [
    {
      icon: Linkedin,
      href: "https://www.linkedin.com/company/infronex-it-products-and-service",
    },
    {
      icon: Instagram,
      href: "https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=xtyu37w",
    },
    { icon: Facebook, href: "https://www.facebook.com/share/15dq6rpGBY/" },
    {
      icon: Mail,
      // This URL forces Gmail to open in a new tab and start a new message
      href: "https://mail.google.com/mail/?view=cm&fs=1&to=info@infronex.com",
    },
  ];

  return (
    <footer className="bg-[#0f172a] text-slate-400 pt-20 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* TOP GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-14 mb-14">
          {/* BRAND */}
          <div className="space-y-6">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h3 className="text-2xl font-black text-white uppercase">
                INFRONEX
              </h3>

              <p className="text-sm leading-relaxed italic max-w-xs mt-3">
                Architecting scalable digital products and enterprise-grade
                software solutions.
              </p>
            </motion.div>

            {/* SOCIAL */}
            <div className="flex gap-3">
              {socialLinks.map((item, i) => {
                const Icon = item.icon;

                return (
                  <a
                    key={i}
                    href={item.href}
                    // Since we are using a web link for Gmail now, we want _blank for all
                    target="_blank"
                    rel="noreferrer"
                    className="w-10 h-10 flex items-center justify-center rounded-xl border border-white/10 hover:border-indigo-500 hover:text-white transition"
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* SERVICES */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
              Services
            </h4>
            <ul className="space-y-4">
              {services.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.href}
                    className="hover:text-indigo-400 text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* PRODUCTS */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
              Products
            </h4>
            <ul className="space-y-4">
              {products.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.href}
                    className="hover:text-indigo-400 text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
              Quick Links
            </h4>
            <ul className="space-y-4">
              {quickLinks.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.href}
                    className="hover:text-indigo-400 text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT / ADDRESS — LAST */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.25em] mb-6">
              Contact Us
            </h4>

            <div className="space-y-5 text-sm">
              {/* ADDRESS */}
              <div className="flex gap-3">
                <MapPin size={18} className="text-indigo-500 mt-1" />
                <span>
                  72/3, SRP Mill Bus Stop,
                  <br />
                  Saravanampatti,
                  <br />
                  Coimbatore – 641035
                </span>
              </div>

              {/* PHONE */}
              <div className="flex gap-3">
                <Phone size={18} className="text-indigo-500 mt-1" />
                <div>
                  <a
                    href="tel:+918248387513"
                    className="block hover:text-white"
                  >
                    +91 82483 87513
                  </a>
                  <a
                    href="tel:+919940932308"
                    className="block hover:text-white"
                  >
                    +91 99409 32308
                  </a>
                </div>
              </div>

              {/* EMAIL */}
              <div className="flex gap-3">
                <Mail size={18} className="text-indigo-500 mt-1" />
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=info@infronex.com"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white"
                >
                  info@infronex.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs uppercase tracking-widest text-slate-500">
          <div className="flex items-center gap-2">
            <Globe2 size={14} className="text-indigo-500" />
            <span>Coimbatore, India</span>
          </div>

          <p>© {currentYear} Infronex IT Products and Services</p>
        </div>
      </div>
    </footer>
  );
}